<template>
  <div class="page-contract-search mwclg-style">
    <div class="order-search" >
      <div class="flex">
        <el-form ref="searchForm" :model="searchForm" style="flex: 1" label-width="100px">
          <el-row :gutter="16">
            <el-col :span="8">
              <el-form-item :label="$t('DomesticWarehousing.InWHNumber') ">
                <el-input v-model="searchForm.consignOrderNoContains" size="small"
                  :placeholder="$t('DomesticWarehousing.PleaseEnter') "></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :label="$t('DomesticWarehousing.IncomingDateFrom') ">
                <!-- <el-date-picker size="small" v-model="searchForm.receiveDateFrom" type="date" value-format="yyyy-MM-dd"
                  :placeholder="$t('DomesticWarehousing.SelectDate') ">
                </el-date-picker> -->
                <el-date-picker v-model="CreateInterval" type="daterange" range-separator="~" format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd" size="small" class="custom-input" />
              </el-form-item>
            </el-col>
            <!-- <el-col :span="8">
              <el-form-item :label="$t('DomesticWarehousing.IncomingDateTo') " label-width="125px">
                <el-date-picker size="small" v-model="searchForm.receiveDateTo" type="date" value-format="yyyy-MM-dd"
                  :placeholder="$t('DomesticWarehousing.SelectDate') ">
                </el-date-picker>
              </el-form-item>
            </el-col> -->
          </el-row>
        </el-form>
        <div style="margin: 0 22px; width: 0.5px; background: #f3f4f6"></div>
        <div style="margin-top: 10px">
          <el-button type="primary" size="small" icon="el-icon-search" @click="search">{{
            $t('DomesticWarehousing.Query') }}</el-button>
          <el-button size="small" icon="el-icon-refresh-right" @click="reset">{{
            $t('DomesticWarehousing.Reset') }}</el-button>
          <el-button size="small" icon="el-icon-download" @click="exportExcel">{{
            $t('DomesticWarehousing.Export') }}</el-button>
        </div>
      </div>
    </div>
    <div class="order-list">
      <p class="title">{{
        $t('DomesticWarehousing.InboundList') }}</p>
      <div>
        <el-table v-loading="loading" :data="dataItems" stripe show-summary :summary-method="getSummaries">
          <el-table-column prop="consignOrderNo" width="180" :label="$t('DomesticWarehousing.InWHNumber')">
          </el-table-column>
          <el-table-column width="100" prop="receiveDate" :label="$t('DomesticWarehousing.InWHDate')">
          </el-table-column>
          <el-table-column width="160" prop="vinNo" :label="$t('DomesticWarehousing.VinNo')">
          </el-table-column>
          <el-table-column width="120" prop="packUnitNameCn" :label="$t('DomesticWarehousing.PackagingUnit')">
          </el-table-column>
          <el-table-column width="100" prop="qty" :label="$t('DomesticWarehousing.Quantity')">
          </el-table-column>
          <el-table-column width="100" prop="volume" :label="$t('DomesticWarehousing.Volume') ">
          </el-table-column>
          <el-table-column width="100" prop="length" :label="$t('DomesticWarehousing.Length')">
          </el-table-column>
          <el-table-column width="100" prop="width" :label="$t('DomesticWarehousing.Width')">
          </el-table-column>
          <el-table-column width="100" prop="hight" :label="$t('DomesticWarehousing.Height')">
          </el-table-column>

          <!-- <el-table-column width="100" prop="whName" :label="$t('DomesticWarehousing.Warehouse')">
          </el-table-column> -->
          <el-table-column width="180" prop="fileCount" :label="$t('DomesticWarehousing.Images')">
            <template #default="scope">
              <el-tooltip v-if="scope.row.fileCount === 0">
                <span>-</span>
              </el-tooltip>
              <span v-else>
                <a :href="scope.row.courseUrl" target="_blank" style="text-decoration:none;"
                  @click="isshow(scope.row.billNo, scope.row.consignOrderNo)">
                  {{ $t('DomesticWarehousing.Preview') }}{{ scope.row.fileCount }}
                </a>
                <a :href="scope.row.courseUrl" target="_blank" style="text-decoration:none;"
                  @click="dowLoad(scope.row.billNo, scope.row.consignOrderNo)">
                  {{ $t('DomesticWarehousing.Download') }}
                </a>
              </span>
              <!-- <a :href="scope.row.courseUrl" target="_blank" style="text-decoration:none;"
                @click="dowLoad(scope.row.billNo, scope.row.consignOrderNo)">
                {{ $t('DomesticWarehousing.Download') }}
              </a> -->
              <el-image-viewer v-if="imgViewerVisible" :initial-index="1" :on-close="closeImgViewer"
                :url-list="dataImgItems">
              </el-image-viewer>
              <!-- <selectFilePic title="" v-if="openDialog" :biz-type.sync="bizType" :consign-OrderNo.sync="consignOrderNo" ref="selectFilePic"/> -->
            </template>

          </el-table-column>
          <el-table-column prop="remark" :label="$t('DomesticWarehousing.Remarks')">
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="pagination-info">
      <div style="color:#999;font-size: 12px;margin-left: 220px;"></div>
      <el-pagination background align="left" @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page.sync="searchForm.pageNo" :page-size.sync="searchForm.pageSize"
        :page-sizes="[10, 20, 50, 100, 1000, 2000]" layout="total, sizes, prev, pager, next, jumper"
        :total="dataCount" />
    </div>
  </div>
</template>
<script>
import BarChart from '@/components/wms/barChart'
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
import {
  parseTime,
  dateAdds
} from '@/utils/index'
import selectFilePic from './selectFilePic';
import { getSearchCFSInboundDataApi, api, getCFSInboundPicDataApi, getCFSDownLoadPicDataApi } from '@/api/wms'
import i18n from '@/i18n/i18n'
export default {
  components: {
    BarChart,
    ElImageViewer,
  },
  props: {
    jobType: {
      type: String,
      default: 'DC'
    },
    customerCode: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      searchForm: {
        consignOrderNoContains: '',
        receiveDateFrom: '',
        receiveDateTo: '',
        ctnNo: '',
        type: '',
        billNo: '',
        Lang: '',
        consignID: this.customerCode,
        pageNo: 1,
        pageSize: 10,
      },
      searchPicForm: {
        billNo: '',
        type: '',
        consignOrderNoContains: '',
      },
      bizType: 'CFSInbound',
      consignOrderNo: '',
      imgViewerVisible: false,
      loading: false,
      dataCount: 0,
      dataItems: [],
      CreateInterval: [
        parseTime(dateAdds(new Date(), -15, 'd'), '{y}-{m}-{d}'),
        parseTime(new Date(), '{y}-{m}-{d}')
      ], 
      dataImgItems: [],
      openDialog: false
    }
  },
  computed: {},
  mounted() {
    this.search();
  },
  methods: {
    async search() {
      this.loading = true
      this.searchForm.receiveDateFrom = this.CreateInterval[0];
      this.searchForm.receiveDateTo = this.CreateInterval[1];
      const lang = this.$ls.get('lang');
      const params = this.searchForm
      params.Lang = lang;
      this.consignOrderNo = this.searchForm.consignOrderNoContains;
      if (this.searchForm.receiveDateFrom == '' || this.searchForm.receiveDateFrom == null) {
        this.$message({
          message: i18n.t('DomesticWarehousing.InStartTimeEm'),
          type: 'warning'
        });
        this.loading = false
        return false;
      }
      if (this.searchForm.receiveDateTo == '' || this.searchForm.receiveDateTo == null) {
        this.$message({
          message: i18n.t('DomesticWarehousing.OutEndTimeEn'),
          type: 'warning'
        });
        this.loading = false
        return false;
      }
      var startdate = new Date(this.searchForm.receiveDateFrom);
      var enddate = new Date(this.searchForm.receiveDateTo);
      var startMonth = new Date(startdate.setMonth(startdate.getMonth() + 1));
      if (enddate > startMonth) {
        this.$message({
          message: i18n.t('DomesticWarehousing.DateMonthCanNot'),
          type: 'warning'
        });
        this.loading = false
        return false;
      }
      var res = await getSearchCFSInboundDataApi(params)
      if (res && res.code == 200) {
        var data = res.data
        this.dataItems = data.items
        this.dataCount = data.count
        this.loading = false
      } else {
        this.$message.error('查询失败');
      }
    },
    exportExcel() {
      this.searchForm.receiveDateFrom = this.CreateInterval[0];
      this.searchForm.receiveDateTo = this.CreateInterval[1];
       const params = this.searchForm
      if (this.searchForm.receiveDateFrom == '' || this.searchForm.receiveDateFrom == null) {
        this.$message({
          message: i18n.t('DomesticWarehousing.InStartTimeEm'),
          type: 'warning'
        });
        this.loading = false
        return false;
      }
      if (this.searchForm.receiveDateTo == '' || this.searchForm.receiveDateTo == null) {
        this.$message({
          message: i18n.t('DomesticWarehousing.OutEndTimeEn'),
          type: 'warning'
        });
        this.loading = false
        return false;
      }
      const lang = this.$ls.get('lang');
      this.searchForm.Lang = lang;
      var startdate = new Date(this.searchForm.receiveDateFrom);
      var enddate = new Date(this.searchForm.receiveDateTo);
      var startMonth = new Date(startdate.setMonth(startdate.getMonth() + 1));
      if (enddate > startMonth) {
        this.$message({
          message: i18n.t('DomesticWarehousing.DateMonthCanNot'),
          type: 'warning'
        });
        this.loading = false
        return false;
      }
      var queryString = Object.keys(this.searchForm).map((key) => {
        return encodeURIComponent(key) + '=' + encodeURIComponent(this.searchForm[key])
      }).join('&')
      const url = api.exportSearchCFSInboundDataApiUrl + '?' + queryString
      window.location.href = url
    },
    reset() {
      this.searchForm = {
        consignOrderNoContains: '',
        receiveDateFrom: '',
        receiveDateTo: '',
        ctnNo: '',
        billNo: '',
        type: '',
        consignID: this.customerCode,
        pageNo: 1,
        pageSize: this.searchForm.pageSize,
      }
    },
    handleSizeChange(val) {
      this.searchForm.pageNo = 1;
      this.searchForm.pageSize = val;
      this.search()
    },
    // 当前页改变时触发 跳转其他页
    handleCurrentChange(val) {
      this.searchForm.pageNo = val;
      this.search()
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      // 保留换行符    选中合计行的每一个元素，然后给每一个元素都添加css样式whiteSpace。
      this.$nextTick(() => {
        const elements = document.querySelectorAll(
          '.el-table__footer-wrapper div.cell'
        );
        elements.forEach(element => {
          // whiteSpace用于控制元素内部空白符（包括空格、换行符等）的处理方式。pre-wrap：表示浏览器会保留连续的空白符和换行符，且会自动换行。
          element.style.whiteSpace = 'pre-wrap';
        });
      });
      // 以下是对小计和总计分别进行赋值
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = i18n.t('DomesticWarehousing.Total');
          return;
        }
        // 将当前列的所有值存储到values中  注：非数字会返回NaN
        const values = data.map(item => Number(item[column.property]));
        // 将要进行小计合计的字段组成一个数组
        const label = ['qty', 'volume', 'netWeight', 'grossWeight'];
        // 如果label包含当前column.property，则进行数据处理
        if (label.includes(column.property)) {
          // 小计
          const Subtotal = values
            .reduce((prev, curr) => {
              const value = Number(curr);
              // 如果是数字则进行累加
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0)
            .toFixed(2);
          // 总计
          sums[index] = Subtotal;
        } else {
          sums[index] = '';
        }
      });
      return sums;
    },
    async isshow(billNo, consignOrderNo) {
      this.searchPicForm.billNo = billNo;
      const params = this.searchPicForm
      var res = await getCFSInboundPicDataApi(params)
      if (res && res.code == 200) {
        var data = res.data;
        this.dataImgItems = data;
        console.log(res.code);
      }
      this.imgViewerVisible = true;
      const m = (e) => { e.preventDefault() };
      document.body.style.overflow = 'hidden';
      document.addEventListener('touchmove', m, false);
      // console.log(consignOrderNo);
      // this.openDialog = true;
      // this.$nextTick(() => {
      //   this.$refs.selectFilePic.init(billNo, consignOrderNo, 'CFSInbound');
      // });
    },
    closeImgViewer() {
      this.imgViewerVisible = false;
      const m = (e) => { e.preventDefault() };
      document.body.style.overflow = 'auto';
      document.removeEventListener('touchmove', m, true);
    },
    async dowLoad(billNo, consignOrderNo) {
      this.searchPicForm.billNo = billNo;
      this.searchPicForm.type = 'CFSInbound';
      this.searchPicForm.consignOrderNoContains = consignOrderNo
      const params = this.searchPicForm
      var res = await getCFSDownLoadPicDataApi(params)
      console.log(res);
      if (res && res.code == 200) {
        var data = res.data;
        window.location.href = data;
        this.open = false;
        //this.reset();
      }
      // window.open(data, '_self');
      // var res = await getCFSInboundPicDataApi(params);
      // var data = data.data;
      // window.open(data, "_self");
    },
  }
}
</script>
<style scoped>

.order-search {
    margin-top: 10px;
    background: white;
    border-radius: 4px;
    padding: 10px 10px;
    height:auto !important;
  }
  .order-list {
    background: white;
    margin-top: 10px;
    border-radius: 4px;
    padding: 10px 10px;
  }
  .order-list .list-item {
      margin-bottom:8px;
    }
  .title {
    font-size: 16px;
    font-weight: 600;
    color: #060606;
    line-height: 22px;
    margin-bottom: 10px;
  }
.pagination-info {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 36px;
    background: #fff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 16px;
    z-index: 3;
  }
</style>
<style>
.el-select ,.el-date-editor.el-input, .el-date-editor.el-input__inner {
  width: 100%;
}
.tms-style .el-input__inner{
  max-width: none;
}
.el-loading-mask{
  z-index: 1000;
}
</style>
